import { useState, useEffect } from "react";
import { fetchNews } from "../lib/api";
import { newsTopics as fallbackNews } from "../data/mock";
import { Newspaper } from "lucide-react";

const NewsTicker = () => {
  const [items, setItems] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    fetchNews()
      .then((data) => setItems(data.length ? data : fallbackNews))
      .catch(() => setItems(fallbackNews));
  }, []);

  useEffect(() => {
    if (items.length === 0) return;
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % items.length);
        setIsVisible(true);
      }, 400);
    }, 5000);
    return () => clearInterval(interval);
  }, [items]);

  if (items.length === 0) return null;
  const topic = items[currentIndex];

  return (
    <section className="bg-[#1C2B3A] border-b border-white/10" data-testid="news-ticker">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-4 flex items-center gap-4 md:gap-6">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Newspaper size={14} className="text-[#B8945A]" />
          <span className="text-[10px] md:text-xs tracking-[0.2em] uppercase text-[#B8945A] font-sans font-bold">
            Insights
          </span>
        </div>
        <div className="w-px h-5 bg-white/20 flex-shrink-0 hidden sm:block"></div>
        <div className="flex-1 overflow-hidden min-w-0">
          <div className="flex items-center gap-3">
            <span className="text-[10px] uppercase tracking-wider text-white/40 font-sans flex-shrink-0 hidden md:inline">
              {topic?.category}
            </span>
            {topic?.link ? (
              <a
                href={topic.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`text-white/75 hover:text-[#B8945A] text-sm font-sans truncate transition-all duration-400 ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
                }`}
                data-testid="news-ticker-headline-link"
              >
                {topic?.headline}
              </a>
            ) : (
              <p
                className={`text-white/75 text-sm font-sans truncate transition-all duration-400 ${
                  isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
                }`}
              >
                {topic?.headline}
              </p>
            )}
          </div>
        </div>
        <div className="flex gap-1 flex-shrink-0">
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => { setCurrentIndex(i); setIsVisible(true); }}
              className={`w-1.5 h-1.5 rounded-full transition-colors duration-200 ${
                i === currentIndex ? "bg-[#B8945A]" : "bg-white/20"
              }`}
              data-testid={`news-dot-${i}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsTicker;
